import React from 'react'
import styled from '@emotion/styled'
import { fontSize3XSmall, fontSize2XSmall, fontWeightBold } from '../../../constants/principles'
import Tab from '../../generic/tab'
import { fontFamilyOpenSans } from '../../../constants/principles'

const SecondaryNavComponent = ({ testId, isImage, displayArrow, tabPrimary, onClickTabItem, activeTab, make, model, bodyStyle, conditionQuestions, navItems, badgeCnt, ...props }) => {
  return (
    <>
      <StyledOl>
        {navItems.map((item, index) => {
          const count =
            badgeCnt[item.toLowerCase()] +
            (badgeCnt[Object.keys(badgeCnt).find(q => q.toLowerCase().startsWith('molding' + item.toLowerCase()))] || 0) +
            ((item.toLowerCase().startsWith('driver') || item.toLowerCase().startsWith('passenger')) &&
              (badgeCnt[Object.keys(badgeCnt).find(q => q.toLowerCase().startsWith('brakes'))] || 0) + (badgeCnt[Object.keys(badgeCnt).find(q => q.toLowerCase().startsWith('tiresrims'))] || 0))
          return (
            <Tab
              key={index}
              testId={`${testId}-tab-${item?.toString().replace(/[^A-Z0-9]/ig, "-").toLowerCase()}`}
              isActive={activeTab === item}
              label={item}
              onClick={e => (e && e.preventDefault()) || onClickTabItem(item)}
              isImage={isImage}
              displayArrow={displayArrow}
              tabPrimary={tabPrimary}
              bodyStyle={bodyStyle}
              make={make}
              model={model}
              count={count}
            />
          )
        })}
      </StyledOl>
    </>
  )
}

export const IconGroup = styled.div`
  align-items: stretch;
  display: flex;
  margin: 8px;
  height: 106px;
  width: 100%;
  justify-content: space-evenly;
  flex-wrap: wrap;
`
export const SubheadingContainer = styled.div`
  padding-bottom: 20px;
  h1 {
    font-size: ${fontSize2XSmall};
    font-weight: ${fontWeightBold};
  }
  span {
    font-size: ${fontSize3XSmall};
  }
`
const StyledOl = styled.ol`
  font-family: ${fontFamilyOpenSans};
  padding-left: 0;
  display: flex;
  justify-content: center;
  cursor: pointer;
  margin-top: 0;
  margin-bottom: 10.5px;
`
export default SecondaryNavComponent
